import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Question } from '../../models/underwriter.model';

@Component({
    selector: 'app-question-sample',
    templateUrl: './question-sample.component.html',
    styleUrls: ['./question-sample.component.scss'],
    standalone: false
})
export class QuestionSampleComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<Question>();

  selectedValue = '';

  constructor() {}

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes.question.currentValue;
      this.selectedValue = this.question?.answer ?? '';
    }
  }

  onSelect(value: string): void {
    this.selectedValue = value;
    this.question.answer = value;
    this.questionAnswer.emit(this.question);
  }
}
